import { restClientGeneral } from 'libs/restClient';
import { generalApiUrl } from 'dictionaries/Env';
import {
  CLEAR_COUNTRY_STATE,
  FETCH_COUNTRIES,
  FETCH_COUNTRY_STATES,
  SHOW_NOTICE
} from 'actions/types';
import { notifyMessages } from 'helpers/NotifyHelper';

export const fetchCountries = () => async dispatch => {
  try {
    const url = `${generalApiUrl}/countries?page=0`;
    const response = await restClientGeneral.get(url);

    dispatch({ type: FETCH_COUNTRIES, payload: response.data.data });
  } catch (e) {
    dispatch({
      type: SHOW_NOTICE,
      payload: notifyMessages.errorFetchRequestAction
    });
  }
};

export const fetchCountryStates = (countryCode, cb) => async dispatch => {
  try {
    const url = `${generalApiUrl}/states?where=country='${countryCode}'&page=0`;
    const response = await restClientGeneral.get(url);

    dispatch({ type: FETCH_COUNTRY_STATES, payload: response.data.data });
    cb();
  } catch (e) {
    dispatch({
      type: SHOW_NOTICE,
      payload: notifyMessages.errorFetchRequestAction
    });
  }
};

export function clearCountryState() {
  return {
    type: CLEAR_COUNTRY_STATE,
    payload: null
  };
}



// WEBPACK FOOTER //
// ./src/actions/countries.js